import gql from 'graphql-tag';

export const towerCamerasFragment = gql`
  fragment towerCamerasPart on TowerCamerasType {
    name
    vmsId
    screenStyleId
    screenViewName
    isPrincipal
    isOnline
    forMobile
    isVirtualControlEnabled
    condominiumPersonContextId
    thumbnail
    thumbnailBase64
    porterVideoChannel
    isSelected
    id
    creationDate
  }
`;

export const deviceModelFragment = gql`
  fragment deviceModelParts on DeviceModel {
    id
    deviceTypeId
    name
    capabilities
    creationDate
  }
`;

export const placeTypeFragment = gql`
  fragment placeTypeParts on PlaceType {
    id
    name
    fieldName
    creationDate
  }
`;

export const deviceTypeFragment = gql`
  fragment deviceTypeParts on DeviceType {
    id
    name
    fieldName
    isCpu
    isController
    creationDate
  }
`;

export const parentDeviceFragment = gql`
  fragment parentDeviceParts on ParentDevice {
    id
    name
    placeId
    deviceType {
      ...deviceTypeParts
    }
    serialNumber
    ip
    isOnline
  }
  ${deviceTypeFragment}
`;

export const deviceFragment = gql`
  fragment devicePartsForTower on Device {
    id
    placeId
    parentDeviceId
    deviceTypeId
    deviceType {
      ...deviceTypeParts
    }
    parentDevice {
      ...parentDeviceParts
    }
    serialNumber
    ip
    protocolVersion
    firmwareVersion
    name
    isOnline
    serializedParams
    creationDate
    lastUpdate
    updateStatus
    chipsetType
    syncStatus
    immutableData
    deviceModel {
      ...deviceModelParts
    }
  }
  ${deviceModelFragment}
  ${deviceTypeFragment}
  ${parentDeviceFragment}
`;

export const placeFragment = gql`
  fragment placePartsForTower on Place {
    id
    name
    treeNodeId
    placeTypeId
    creationDate
    serializedParams
    comments
    placeType {
      ...placeTypeParts
    }
    devices {
      ...devicePartsForTower
    }
  }
  ${placeTypeFragment}
  ${deviceFragment}
`;

export const interlockedPlaceFragment = gql`
  fragment interlockedPlacePartsForTower on InterlockedPlace {
    id
    name
    pausedReason
    pausedUntil
    places {
      place {
        ...placePartsForTower
      }
    }
    creationDate
  }
  ${placeFragment}
`;

export const placeInterlockableFragment = gql`
  fragment placeInterlockablePartsForTower on PlaceInterlockable {
    id
    name
    treeNodeId
    placeTypeId
    creationDate
    serializedParams
    comments
    totalCameras
    order
    accessRf {
      id
      placeId
      parentDeviceId
      deviceTypeId
      serialNumber
      ip
      protocolVersion
      firmwareVersion
      name
      isOnline
      serializedParams
      creationDate
      lastUpdate
    }
    placeType {
      ...placeTypeParts
    }
    devices {
      ...devicePartsForTower
    }
    interlockedPlaces {
      ...interlockedPlacePartsForTower
    }
  }
  ${placeTypeFragment}
  ${deviceFragment}
  ${interlockedPlaceFragment}
`;

export const towerCameraFragment = gql`
  fragment towerCameraPart on TowerCamera {
    id
    stream
    thumbnail
  }
`;

export const towerFragment = gql`
  fragment towerPart on Tower {
    id
    name
    totalCameras
    cameras {
      ...towerCameraPart
    }
  }
  ${towerCameraFragment}
`;
